"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabs = exports.tabsContext = void 0;
var react_1 = require("react");
exports.tabsContext = react_1.createContext(null);
function useTabs() {
    var context = react_1.useContext(exports.tabsContext);
    if (context == null) {
        throw Error('TabPane should be used in Tabs.');
    }
    return context;
}
exports.useTabs = useTabs;
//# sourceMappingURL=hook.js.map